import React from 'react';
import Navbar from './components/Navbar';
import weddingPhoto from '../images/wedding-day-photo.jpg';

class Gallery extends React.Component {
    componentDidMount() {
        const { handleInfoData } = this.props;
        handleInfoData('gallery');
    }

    render() {
        const { galleryData } = this.props;
        return(
            <div className="App">
                <Navbar/>
                <h1 className="App-section-title">Gallery</h1>
                <img src={weddingPhoto} className="img-center" alt="wedding at de seversky mansion"/>
                <p className="caption">Photo by <a href="https://www.reypaulweddings.com/" target="_blank" rel="noopener noreferrer">Rey Paul Weddings</a></p>
                <div className="App-details">
                    <p>{galleryData.info} <a href={galleryData.URL} target="_blank" rel="noopener noreferrer"><span className="underline">{galleryData.linkText}</span></a> {galleryData.text}</p>
                </div>
            </div>
        )
    }
}

export default Gallery;